import React from 'react';
import { IonCard, IonSkeletonText, IonList } from '@ionic/react';

export const GamesListSkeletonLoader = () => (
  <IonCard>
    <div
      style={{
        display: 'flex',
        justifyContent: 'left',
        alignItems: 'center',
        height: '60px',
        paddingTop: '2px',
        paddingBottom: '2px',
        borderRadius: '4px',
        overflow: 'hidden',
      }}>
      <div
        style={{
          width: '44%',
          height: '100%',
          clipPath: 'polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%)',
          borderRadius: '4px',
          marginLeft: '10px',
          paddingBottom: '8px',
          paddingTop: '1px',
        }}>
        <IonSkeletonText animated style={{ width: '100%', height: '100%' }} />
      </div>
      <div
        style={{
          width: '44%',
          height: '100%',
          clipPath: 'polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)',
          borderRadius: '4px',
          position: 'relative',
          marginLeft: '0px',
          right: '20px',
          paddingBottom: '9px',
          top: '1px',
        }}>
        <IonSkeletonText animated style={{ width: '100%', height: '100%' }} />
      </div>
      <div
        style={{
          width: '15%',
          height: '100%',
          borderRadius: '4px',
          paddingBottom: '9px',
          position: 'relative',
          right: '4%',
          marginLeft: '10px',
          paddingTop: '1px',
        }}>
        <IonSkeletonText animated style={{ width: '100%', height: '100%' }} />
      </div>
    </div>
  </IonCard>
);

export const TeamOutcomesLoader = () => (
  <div
    style={{
      display: 'flex',
      flexWrap: 'wrap',
      gap: '10px',
      width: '100%',
      background: '#f4dfc7',
    }}>
    <IonList style={{ flex: 1, background: '#f4dfc7' }}>
      {[...Array(3)].map((_, idx) => (
        <IonCard
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
          style={{
            padding: '16px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '40px',
            width: '90%',
            marginBottom: '13px',
          }}>
          <IonSkeletonText
            animated
            style={{
              width: '80%',
              height: '16px',
              margin: '0 auto',
              borderRadius: '4px',
            }}
          />
        </IonCard>
      ))}
    </IonList>

    <div
      style={{
        width: '1px',
        backgroundColor: '#a0a0a0',
      }}
    />
    <IonList style={{ flex: 2, background: '#f4dfc7' }}>
      {[...Array(2)].map((_, idx) => (
        <IonCard
          // eslint-disable-next-line react/no-array-index-key
          key={idx}
          style={{
            padding: '16px',
            textAlign: 'center',
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            height: '60px',
            width: '90%',
            marginBottom: '8px',
          }}>
          <IonSkeletonText
            animated
            style={{
              width: '80%',
              height: '16px',
              margin: '0 auto',
              borderRadius: '4px',
            }}
          />
        </IonCard>
      ))}
    </IonList>
  </div>
);

export const MatchmakingFightCardLoader = () => (
  <IonCard>
    <div style={{ position: 'relative', padding: '2px' }}>
      <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '2px' }}>
        <IonSkeletonText
          animated
          style={{
            width: '50%',
            height: '16px',
            borderRadius: '4px',
          }}
        />
      </div>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          height: '70px',
          paddingTop: '2px',
          paddingBottom: '2px',
          borderRadius: '8px',
          overflow: 'hidden',
          width: '80%',
        }}>
        <div
          style={{
            width: '35%',
            height: '100%',
            clipPath: 'polygon(0% 0%, 100% 0%, 80% 100%, 0% 100%)',
            borderRadius: '8px',
            marginLeft: '10px',
            paddingBottom: '8px',
            paddingTop: '1px',
          }}>
          <IonSkeletonText animated style={{ width: '100%', height: '100%' }} />
        </div>
        <div
          style={{
            width: '35%',
            height: '100%',
            clipPath: 'polygon(20% 0%, 100% 0%, 100% 100%, 0% 100%)',
            borderRadius: '8px',
            position: 'relative',
            right: '20px',
            paddingBottom: '9px',
            top: '1px',
          }}>
          <IonSkeletonText animated style={{ width: '100%', height: '100%' }} />
        </div>
        <div
          style={{
            width: '15%',
            height: '100%',
            borderRadius: '8px',
            paddingBottom: '9px',
            position: 'relative',
            right: '6%',
            paddingTop: '1px',
          }}>
          <IonSkeletonText animated style={{ width: '100%', height: '100%' }} />
        </div>
      </div>
      <div
        style={{
          width: '20%',
          height: '100%',
          position: 'absolute',
          top: '-2px',
          right: '0',
          borderRadius: '8px',
          overflow: 'hidden',
        }}>
        <IonSkeletonText animated style={{ width: '100%', height: '100%' }} />
      </div>
    </div>
  </IonCard>
);

export const SingleLineLoader = () => (
  <IonCard
    style={{
      padding: '16px',
      textAlign: 'center',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '60px',
      width: '48%',
      margin: '0',
      marginBottom: '3px',
    }}>
    <IonSkeletonText
      animated
      style={{
        width: '80%',
        height: '16px',
        margin: '0 auto',
        borderRadius: '4px',
      }}
    />
  </IonCard>
);

export const SingleBoxLoader = () => (
  <IonCard
    style={{
      padding: '2px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      height: '60px',
      width: '23%',
      alignItems: 'center',
      margin: '1%,',
    }}>
    <IonSkeletonText
      animated
      style={{
        width: '80%',
        height: '100%',
        borderRadius: '4px',
        alignItems: 'center',
      }}
    />
  </IonCard>
);

export const FightHistoryLoader = () => (
  <IonCard
    style={{
      display: 'flex',
      flexDirection: 'column',
      padding: '10px',
    }}>
    <div style={{ width: '100%', marginBottom: '12px' }}>
      <IonSkeletonText animated style={{ width: '100%', height: '16px', borderRadius: '4px' }} />
    </div>
    <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
      <div
        style={{
          width: '25%',
          height: '70px',
          borderRadius: '8px 0 0 8px',
          marginRight: '12px',
          overflow: 'hidden',
        }}>
        <IonSkeletonText animated style={{ width: '100%', height: '100%' }} />
      </div>

      <div style={{ flex: '1', marginRight: '8px' }}>
        <div style={{ marginBottom: '8px' }}>
          <IonSkeletonText animated style={{ width: '80%', height: '12px', borderRadius: '4px' }} />
        </div>
        <div style={{ marginBottom: '8px' }}>
          <IonSkeletonText animated style={{ width: '40%', height: '12px', borderRadius: '4px' }} />
        </div>
        <div style={{ marginBottom: '8px' }}>
          <IonSkeletonText animated style={{ width: '20%', height: '12px', borderRadius: '4px' }} />
        </div>
        <div style={{ marginBottom: '8px' }}>
          <IonSkeletonText animated style={{ width: '40%', height: '12px', borderRadius: '4px' }} />
        </div>
      </div>
    </div>
  </IonCard>
);

export const LiveFightsLoader = () => (
  <IonCard style={{ padding: '12px', borderRadius: '8px' }}>
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        position: 'relative',
        marginBottom: '8px',
      }}>
      {/* This is a skeleton for opponent, food-items, and venue informaiton */}
      <div style={{ display: 'flex', flexDirection: 'column', width: '60%' }}>
        <IonSkeletonText animated style={{ height: '14px', borderRadius: '4px', justifyContent: 'start' }} />
        <IonSkeletonText animated style={{ height: '14px', borderRadius: '4px', justifyContent: 'start' }} />
      </div>
      {/* This is a skeleton for match's time */}
      <IonSkeletonText
        animated
        style={{ width: '20%', height: '12px', borderRadius: '4px', justifyContent: 'start' }}
      />
    </div>
    <div style={{ backgroundColor: '#F4F4F4', margin: '0 -12px', position: 'relative' }}>
      <div style={{ display: 'flex', padding: '14px 14px 8px 14px', alignItems: 'end' }}>
        <IonSkeletonText
          animated
          style={{
            height: '64px',
            borderRadius: '8px',
            justifyContent: 'start',
            clipPath: 'polygon(100% 0, 100% 34%, 90% 100%, 0 100%, 0 0)',
          }}
        />
        <IonSkeletonText
          animated
          style={{
            height: '42px',
            borderRadius: '8px',
            justifyContent: 'start',
            clipPath: 'polygon(100% 0, 100% 34%, 100% 100%, 0 100%, 10% 0)',
          }}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'center', padding: '0 12px 12px 12px' }}>
        <IonSkeletonText animated style={{ width: '80%', height: '16px', borderRadius: '4px' }} />
      </div>
    </div>
    <div style={{ display: 'flex', justifyContent: 'center', marginTop: '12px' }}>
      <IonSkeletonText animated style={{ width: '30%', height: '20px', borderRadius: '4px' }} />
    </div>
  </IonCard>
);

export const EditProfileLoader = () => (
  <IonCard style={{ padding: '12px' }}>
    <div
      style={{
        width: '100%',
        height: '65vh',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-evenly',
        overflow: 'hidden',
      }}>
      <IonSkeletonText animated style={{ width: '100%', height: '56px', borderRadius: '24px' }} />
      <IonSkeletonText animated style={{ width: '100%', height: '56px', borderRadius: '24px' }} />
      <IonSkeletonText animated style={{ width: '100%', height: '56px', borderRadius: '24px' }} />
      <IonSkeletonText animated style={{ width: '100%', height: '56px', borderRadius: '24px' }} />
      <IonSkeletonText animated style={{ width: '100%', height: '56px', borderRadius: '24px' }} />
      <IonSkeletonText animated style={{ width: '100%', height: '56px', borderRadius: '24px' }} />
    </div>
  </IonCard>
);

export const FriendsListItemLoader = () => (
  <div
    style={{
      paddingLeft: '10px',
      backgroundColor: '#f6f6f6',
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      alignItems: 'center',
      position: 'relative',
      marginBottom: '10px',
      height: '4rem',
      borderRadius: '10px',
      border: '2px solid #666666',
      margin: '16px',
    }}>
    <div style={{ display: 'flex', gap: '8px' }}>
      <div style={{ width: '3rem' }}>
        <IonSkeletonText animated style={{ borderRadius: '10px', height: '2.5rem', width: '100%' }} />
      </div>
      <div style={{ width: '5rem', alignContent: 'center' }}>
        <IonSkeletonText animated style={{ borderRadius: '8px', height: '1.5em', width: '100%' }} />
      </div>
    </div>
    <div style={{ width: '5rem', textAlign: 'right', height: '100%' }}>
      <IonSkeletonText
        animated
        style={{
          borderRadius: '10px',
          height: '100%',
          width: '100%',
          display: 'block',
          lineHeight: '0',
          margin: '0',
          verticalAlign: 'top',
        }}
      />
    </div>
  </div>
);

export const PickChallengerItemLoader = () => (
  <div style={{ height: '60px', width: '100%' }}>
    <IonSkeletonText className='skeletal-fighter-tile' animated style={{ borderRadius: '10px', margin: '0' }} />
  </div>
);

export const RecentChatItemLoader = () => (
  <div style={{ paddingLeft: '10px', paddingRight: '10px', backgroundColor: '#faf7ec' }}>
    <IonSkeletonText
      animated
      style={{
        borderRadius: '10px',
        height: '50px',
        padding: '3px',
        marginBottom: '7px',
        backgroundColor: '#e5e1d7',
      }}
    />
  </div>
);
